import React from 'react';
import * as BuilderInfoUI from '../BuilderInfoUI';

interface IProps {
  name: string;
}

export default ({ name }: IProps) => (
  <BuilderInfoUI.PlainInfo>
    <BuilderInfoUI.InfoLabel>Schema</BuilderInfoUI.InfoLabel>
    <BuilderInfoUI.PlainValue>{name}</BuilderInfoUI.PlainValue>
  </BuilderInfoUI.PlainInfo>
);
